import { FunctionComponent } from 'react'
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  VStack,
  Spacer,
  FormControl,
  FormLabel,
  Input,
} from '@chakra-ui/react'
import { IMesh } from '../../../type/modelType'
import ColorConfig from './colorConfig'
import TextureConfig from './textureConfig'
import VariantConfig from './variantConfig'
import { Shop } from '../../../type/backendType'
import { ChevronDownIcon, ChevronRightIcon } from '@chakra-ui/icons'

interface IProps {
  shop: Shop
  mesh: IMesh
  setMesh: React.Dispatch<React.SetStateAction<IMesh | null>>
}

const MeshConfig: FunctionComponent<IProps> = ({ mesh, setMesh, shop }) => {
  return (
    <VStack spacing={2}>
      <FormControl id="title" isRequired>
        <FormLabel>Title</FormLabel>
        <Input
          placeholder="Title"
          value={mesh.title}
          onChange={e => {
            setMesh({
              ...mesh,
              title: e.target.value,
            })
          }}
        />
      </FormControl>
      <Spacer />
      <Accordion w="100%" allowToggle>
        <AccordionItem>
          {({ isExpanded }) => (
            <>
              <h2>
                <AccordionButton>
                  <Box flex="1" textAlign="left">
                    Color / Material
                  </Box>
                  {isExpanded ? (
                    <ChevronDownIcon fontSize="lg" />
                  ) : (
                    <ChevronRightIcon fontSize="lg" />
                  )}
                </AccordionButton>
              </h2>
              <AccordionPanel pb={4}>
                <Tabs isFitted marginInline="-30px">
                  <TabList>
                    <Tab>Color</Tab>
                    <Tab>Material</Tab>
                  </TabList>

                  <TabPanels>
                    <TabPanel>
                      <ColorConfig mesh={mesh} setMesh={setMesh} shop={shop} />
                    </TabPanel>
                    <TabPanel>
                      <TextureConfig
                        mesh={mesh}
                        setMesh={setMesh}
                        shop={shop}
                      />
                    </TabPanel>
                  </TabPanels>
                </Tabs>
              </AccordionPanel>
            </>
          )}
        </AccordionItem>

        <AccordionItem>
          {({ isExpanded }) => (
            <>
              <h2>
                <AccordionButton>
                  <Box flex="1" textAlign="left">
                    Variant
                  </Box>
                  {isExpanded ? (
                    <ChevronDownIcon fontSize="lg" />
                  ) : (
                    <ChevronRightIcon fontSize="lg" />
                  )}
                </AccordionButton>
              </h2>
              <AccordionPanel pb={4}>
                <VariantConfig mesh={mesh} setMesh={setMesh} />
              </AccordionPanel>
            </>
          )}
        </AccordionItem>
      </Accordion>
    </VStack>
  )
}

export default MeshConfig
